import script from "./TaskPriorityIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskPriorityIcon.vue?vue&type=script&setup=true&lang=js"

import "./TaskPriorityIcon.vue?vue&type=style&index=0&id=068cd5e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-068cd5e1"]])

export default __exports__